<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('novo-grupoeconomico') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="permissao.create"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(22)"
                                ref="idErpInput"
                                v-model="grupoeconomico.idgrupoeconomicoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!grupoeconomico.idgrupoeconomicoerp"
                                uppercase
                            />
                        </div>

                        <div class="column is-6">
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="grupoeconomico.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="grupo-economico"
                                msg="msg-campo-obrigatorio"
                                :invalid="!grupoeconomico.descricao"
                                uppercase
                                :required="true"
                                tooltipLabel="informacao-grupo-economico-descricao"
                                tooltipSize="is-small"
                            />
                        </div>
                        <div class="column is-2">
                            <label for="situacao" v-text="$t('situacao')" />
                            <vss-select
                                :id="generateId(4)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="grupoeconomico.id == null"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GrupoEconomicoService from '@/services/agro/GrupoEconomicoService.js';
import GrupoEconomicoValidation from '@/services/validations/GrupoEconomicoValidation';
import Message from '@/models/Message';

export default {
    props: {
        idtipocultura: 0,
        permissaoVincular: false,
    },
    data() {
        return {
            service: new GrupoEconomicoService(this.$http, this.$router),
            validation: new GrupoEconomicoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            grupoeconomico: {
                idgrupoeconomico: null,
                idgrupoeconomicoerp: null,
                descricao: '',
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'cli-grupoeconomico');

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cli-grupoeconomico' },
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        save() {
            this.isLoading = true;
            let grupoeconomicoTemp = Object.assign({}, this.grupoeconomico);
            grupoeconomicoTemp = this.mapTosave(grupoeconomicoTemp);
            grupoeconomicoTemp.situacao = this.situacao.id;

            if (this.validation.validate(this.grupoeconomico, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(grupoeconomicoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-grupo-economico';
                            if (this.grupoeconomico.idgrupoeconomico != null) {
                                msg = 'msg-edit-grupo-economico';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            this.$emit('fecharModal', value.content);
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        if (e.body && e.body.message && this.$te(e.body.message)) {
                            let message = e.body.message;
                            let msgErro;
                            if (message == 'msg-codigo-duplicado-n') {
                                msgErro = this.$t(e.body.message, 
                                    { n: grupoeconomicoTemp.idgrupoeconomicoerp }
                                );
                            } else {
                                msgErro = this.$t(message);
                            }
                            this.msgs.push(new Message('alert', msgErro, true, false));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.runValidations();
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        runValidations(focusedOut = false) {
            if (focusedOut) {
                // Utilizado para ativar a validação dos campos ao carregar os dados de alteração
                Object.entries(this.$refs).forEach(([key, value]) => {
                    value.focusedOut = true;
                });
            }
        },
        onFecharModal() {
            this.$emit('fecharModal');
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
